import * as Yup from 'yup'
import "yup-phone";

const NAME_REGEX = /^(?! )[A-Za-z]+(?: [A-Za-z]+)?$/;

export const userSchema = () =>
  Yup.object().shape({
    email: Yup.string().email('Invalid Email').max(50).required('Email Required'),
    firstName: Yup.string()
  .matches(NAME_REGEX, "Only characters are allowed")
  .min(3, "Minimum 3 characters required")
  .max(50, "Maximum 50 characters allowed")
  .required("First Name is required"),

lastName: Yup.string()
  .matches(NAME_REGEX, "Only characters are allowed")
  .min(3, "Minimum 3 characters required")
  .max(50, "Maximum 50 characters allowed")
  .required("Last Name is required"),
    // firstName: Yup.string().min(3, 'Minimum 3 Characters Required').max(50, 'Maximum 50 Characters Allowed').required('First Name Required'),
    // lastName: Yup.string().min(3, 'Minimum 3 Characters Required').max(50, 'Maximum 50 Characters Allowed').required('Last Name Required'),
    phone: Yup.string().required(),
    dateOfBirth: Yup.date().max(new Date(new Date().getFullYear() - 18, new Date().getMonth(), new Date().getDate() - 1), 'Must Be 18 Years Old').required('DOB Required'),
    gender: Yup.string().required('Gender Required'),
    username: Yup.string().max(20, 'Maximum 20 Characters Allowed').min(3, 'Minimum 3 Characters Required').required('User Name Required'),
    address: Yup.string().max(100, 'Maximum 100 Characters Allowed').required('Address Required'),
    currencyCode: Yup.string(),
    countryCode: Yup.string().nullable(),
    profileNotes: Yup.string()
      .max(200, 'Maximum 200 Characters Allowed')
      .nullable()
  })
